import { atom } from 'jotai'

import type { DataPoint } from '@app/components/Molecules/Charts/ProjectedExposureChart/ProjectedExposureChart'

export interface ProjectedExposureChartState {
  [hazardId: string]: {
    data: DataPoint[]
    parameter: string
    parameterTitle: string
    x_unit: string
    y_unit: string | null
  }
}

export const projectedExposureChartStateAtom = atom<ProjectedExposureChartState>({})
